import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ExternalLinkSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3629 2.49548C21.6089 2.72922 21.6931 3.06603 21.607 3.35643L21.5193 11.8128C21.5145 12.2689 21.1386 12.6124 20.6796 12.58C20.2206 12.5477 19.8524 12.1517 19.8571 11.6955L19.924 5.24718L10.2935 15.3692C9.98745 15.6909 9.46201 15.6882 9.11993 15.3632C8.77785 15.0383 8.74868 14.514 9.05476 14.1923L18.8416 3.90596H12.0467C11.5885 3.90596 11.1945 3.53526 11.1668 3.07798C11.139 2.6207 11.4879 2.25 11.9461 2.25H20.7279L20.7431 2.25014C20.9617 2.24616 21.1866 2.32803 21.3629 2.49548ZM3.32157 7.20042C2.86339 7.20042 2.48811 7.57196 2.48337 8.03029L2.35002 20.9201C2.34528 21.3785 2.71287 21.75 3.17105 21.75H15.9276C16.3858 21.75 16.7611 21.3785 16.7658 20.9201L16.8325 14.4752C16.8372 14.0169 16.4696 13.6453 16.0115 13.6453C15.5533 13.6453 15.178 14.0169 15.1733 14.4752L15.1152 20.0902H4.01784L4.13402 8.86017H9.68268C10.1409 8.86017 10.5161 8.48862 10.5209 8.03029C10.5256 7.57196 10.158 7.20042 9.69985 7.20042H3.32157Z"
        fill={color}
      />
    </svg>
  );
};

export { ExternalLinkSvg };
